import { combineReducers } from "redux";
import {
  GET_ORDER_INVOICE,
  GET_ORDER_INVOICE_OK,
  GET_ORDER_INVOICE_ERR,
  DO_ORDER_INVOICE_CLEANUP,
} from './actionTypes';

/********* SINGLE *********/
const defaultSingleState = {
  invoice: null,
  invoiceError: null,
  isLoadInProgress: false,
}

const Single = (state = defaultSingleState, action) => {
  switch (action.type) {
    case GET_ORDER_INVOICE:
      state = {
        ...state,
        invoiceError: null,
        isLoadInProgress: true,
      };
      break
    case GET_ORDER_INVOICE_OK:
      state = {
        ...state,
        invoice: action.payload.response.invoice,
        isLoadInProgress: false,
      };
      break
    case GET_ORDER_INVOICE_ERR:
      state = {
        ...state,
        invoice: null,
        invoiceError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_ORDER_INVOICE_CLEANUP:
      state = { ...defaultSingleState };
      break
  }

  return state;
}

export default combineReducers({
  Single,
})